import React, { useState, useContext, useEffect } from 'react'
import { Table, Switch, Radio, Select, Col, Checkbox, Row, Input, Button, Space, Tooltip } from 'antd';
import { TokenVerificationLoggedin, ScreenView, Block_U_Admin } from "../../utils/tokenVerify";
import DownloadOrangeIcon from '../../assets/images/icons/download_csv_icon.svg';
import FileIcon from '../../assets/images/icons/offcanva_file_icon.svg';
import deleteIcon from '../../assets/images/icons/trash.svg';
import uploadIcon from '../../assets/images/icons/upload-cloud.svg';
import { LoadingContext } from "react-router-loading";
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../../config/config.json";
import constantData from "../../constants/constantData.json";
import { jwtDecode } from "jwt-decode";
import { notifyfailure, notifysuccess, notifycatch } from "../../utils/toast";

const AccountSetting = () => {
    const loadingContext = useContext(LoadingContext);
    const [checkRole, setCheckRole] = useState("admin")
    const [initialValues, setInitialValues] = useState(null);
    const [isDirty, setIsDirty] = useState(false);

    const [initialPubData, setInitialPubData] = useState(null);

    useEffect(() => {
        TokenVerificationLoggedin();
        ScreenView()
        Block_U_Admin()


        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            let checkRole = jwtDecode(token).role;
            setCheckRole(checkRole)


            axios
                .get((configData.SERVER_URL + "ops/getPubDetails?_id="), {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {

                    setDefineYourself(response?.data?.data?.defineYourself || [])
                    setIsMcm(response?.data?.data?.isMcm ?? null)
                    setGamEmail(response?.data?.data?.gamEmail || "")
                    setGamNetworkId(response?.data?.data?.gamNetworkCode || "")
                    setRegulationAdserver(response?.data?.data?.regulation_brand_safety_adserver || "")
                    setSellerType(response?.data?.data?.s_type || "")
                    setSellerName(response?.data?.data?.s_name || "")
                    setSellerDomain(response?.data?.data?.s_domain || "")
                    setIsSellerPassThroughCheckbox(response?.data?.data?.isSellerPassThrough_checkbox || false)

                    const apiData = response?.data?.data || {};
                    // setInitialPubData(sanitizePubData(apiData));
                    setInitialPubData(apiData);

                    const initial = {
                        defineYourself: response?.data?.data?.defineYourself || [],
                        isMcm: response?.data?.data?.isMcm ?? null,
                        gamEmail: response?.data?.data?.gamEmail || "",
                        gamNetworkId: response?.data?.data?.gamNetworkCode || "",
                        regulationAdserver: response?.data?.data?.regulation_brand_safety_adserver || "",
                        sellerType: response?.data?.data?.s_type || "",
                        sellerName: response?.data?.data?.s_name || "",
                        sellerDomain: response?.data?.data?.s_domain || "",
                        isSellerPassThroughCheckbox:
                            response?.data?.data?.isSellerPassThrough_checkbox || false,
                    };

                    setInitialValues(initial);
                })
                .catch((error) => {
                    notifyfailure("Failed to fetch the publisher details.")
                });



        }

        loadingContext.done()
    }, [loadingContext]);



    const [tab, setTab] = useState("accountSettings")
    const [buttonValue, setButtonValue] = useState(false);


    const [defineYourself, setDefineYourself] = useState([]);
    const [defineYourselfIsRequiredError, setDefineYourselfIsRequiredError] = useState(false);

    const [isMcm, setIsMcm] = useState(null);
    const [isMcmIsRequiredError, setIsMcmIsRequiredError] = useState(false);
    const [gamEmail, setGamEmail] = useState("");
    const [gamEmailIsRequiredError, setGamEmailIsRequiredError] = useState(false);
    const [gamEmailUrlError, setGamEmailUrlError] = useState(false);
    const [gamNetworkId, setGamNetworkId] = useState("");
    const [gamNetworkIdIsRequiredError, setGamNetworkIdIsRequiredError] = useState(false);

    const [regulationAdserver, setRegulationAdserver] = useState("");
    const [regulationAdserverIsRequiredError, setRegulationAdserverIsRequiredError] = useState(false);

    const [sellerType, setSellerType] = useState("");
    const [sellerTypeIsRequiredError, setSellerTypeIsRequiredError] = useState(false);
    const [sellerName, setSellerName] = useState("");
    const [sellerNameIsRequiredError, setSellerNameIsRequiredError] =
        useState(false);
    const [sellerDomain, setSellerDomain] = useState("");
    const [sellerDomainIsRequiredError, setSellerDomainIsRequiredError] =
        useState(false);
    const [sellerDomainUrlError, setSellerDomainUrlError] = useState(false);
    const [isSellerPassThroughCheckbox, setIsSellerPassThroughCheckbox] =
        useState(false);

    const normalizeArray = (arr = []) =>
        [...arr].sort();

    useEffect(() => {
        if (!initialValues) return;

        const hasChanged =
            JSON.stringify(normalizeArray(defineYourself)) !==
            JSON.stringify(normalizeArray(initialValues.defineYourself)) ||
            isMcm !== initialValues.isMcm ||
            gamEmail !== initialValues.gamEmail ||
            gamNetworkId !== initialValues.gamNetworkId ||
            regulationAdserver !== initialValues.regulationAdserver ||
            sellerType !== initialValues.sellerType ||
            sellerName !== initialValues.sellerName ||
            sellerDomain !== initialValues.sellerDomain ||
            isSellerPassThroughCheckbox !==
            initialValues.isSellerPassThroughCheckbox;

        setIsDirty(hasChanged);
    }, [
        defineYourself,
        isMcm,
        gamEmail,
        gamNetworkId,
        regulationAdserver,
        sellerType,
        sellerName,
        sellerDomain,
        isSellerPassThroughCheckbox,
        initialValues
    ]);

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    const validateWebsiteUrl = (websiteUrl) => {
        return String(websiteUrl)
            .toLowerCase()
            .match(/.+[.].+/);
    };


    function onChangeDefineYourself(event) {
        if (event.length === 0) {
            setDefineYourselfIsRequiredError(true)
        }
        else {
            setDefineYourselfIsRequiredError(false)
        }

        setDefineYourself(event)
    }

    function onChangeIsMcm(event) {
        setIsMcmIsRequiredError(false)
        setIsMcm(event.target.value);
    }

    function onChangeGamEmail(event) {
        setGamEmailIsRequiredError(false);
        setGamEmail(event.target.value);

        if (validateEmail(event.target.value) === null) {
            setGamEmailUrlError(true);
        } else {
            setGamEmailUrlError(false);
        }
    }

    function onBlurGamEmail(event) {
        if (event.target.value.trim().length === 0) {
            setGamEmailUrlError(false);
            setGamEmailIsRequiredError(true);
        }
        else {
            if (validateEmail(event.target.value.trim()) === null) {
                setGamEmailUrlError(true);
            } else {
                setGamEmailUrlError(false);
            }
        }
        setGamEmail(event.target.value.trim());
    }


    function onChangeGamNetworkId(event) {
        setGamNetworkIdIsRequiredError(false);
        setGamNetworkId(event.target.value);
    }

    function onBlurGamNetworkId(event) {
        if (event.target.value.trim().length === 0) {
            setGamNetworkIdIsRequiredError(true);
        }
        setGamNetworkId(event.target.value.trim());
    }

    function onChangeRegulationAdserver(event) {
        setRegulationAdserverIsRequiredError(false);
        setRegulationAdserver(event.target.value);
    }

    function onBlurRegulationAdserver(event) {
        if (event.target.value.trim().length === 0) {
            setRegulationAdserverIsRequiredError(true);
        }
        setRegulationAdserver(event.target.value.trim());
    }

    function onChangeSellerType(event) {
        setSellerTypeIsRequiredError(false)
        setSellerType(event.target.value);
    }

    function onChangeSellerName(event) {
        setSellerNameIsRequiredError(false);
        setSellerName(event.target.value);
    }

    function onBlurSellerName(event) {
        if (event.target.value.trim().length === 0) {
            setSellerNameIsRequiredError(true);
        }
        setSellerName(event.target.value.trim());
    }

    function onChangeSellerDomain(event) {
        setSellerDomain(event.target.value);

        if (event.target.value.length === 0) {
            setSellerDomainUrlError(false);
            setSellerDomainIsRequiredError(true);
        } else {
            setSellerDomainIsRequiredError(false);

            if (validateWebsiteUrl(event.target.value) === null) {
                setSellerDomainUrlError(true);
            } else {
                setSellerDomainUrlError(false);
            }
        }
    }

    function onBlurSellerDomain(event) {
        if (event.target.value.trim().length === 0) {
            setSellerDomainUrlError(false);
            setSellerDomainIsRequiredError(true);
        } else {
            if (validateWebsiteUrl(event.target.value.trim()) === null) {
                setSellerDomainUrlError(true);
            } else {
                setSellerDomainUrlError(false);
            }
        }
        setSellerDomain(event.target.value.trim());
    }

    function onChangeIsSellerPassThroughCheckbox(event) {
        setIsSellerPassThroughCheckbox(event.target.checked);
    }


    const objectToFormData = (obj) => {
        const formData = new FormData();

        Object.entries(obj).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                formData.append(key, JSON.stringify(value));
            } else if (value !== undefined && value !== null) {
                formData.append(key, value);
            }
        });

        return formData;
    };

    const buildFinalPayload = () => {
        if (!initialPubData) return null;

        return {
            ...initialPubData, // ✅ ALL keys preserved

            // 🔥formatted keys
            im: JSON.stringify(initialPubData.im),
            defineYourself: JSON.stringify(initialPubData.defineYourself),
            inventory_type_select: JSON.stringify(initialPubData.inventory_type_select),
            ad_format_monetise: JSON.stringify(initialPubData.ad_format_monetise),
            ad_format_monetise_other: JSON.stringify(initialPubData.ad_format_monetise_other),
            integration_type: JSON.stringify(initialPubData.integration_type),
            ortb_type: JSON.stringify(initialPubData.ortb_type),
            vast_type: JSON.stringify(initialPubData.vast_type),
            integration_protocol_rich_media_creative: JSON.stringify(initialPubData.integration_protocol_rich_media_creative),
            blockCategory: JSON.stringify(initialPubData.blockCategory),
            bcate_data: JSON.stringify(initialPubData.bcate_data),

            inventoryWebsiteData: initialPubData.inventory_type_select.includes("Website") ? JSON.stringify(initialPubData.inventoryWebsiteData) : [],
            inventoryMobileData: initialPubData.inventory_type_select.includes("Mobile App (Android / iOS)") ? JSON.stringify(initialPubData.inventoryMobileData) : [],
            inventoryCtvData: initialPubData.inventory_type_select.includes("CTV / FAST Apps") ? JSON.stringify(initialPubData.inventoryCtvData) : [],


            //keys to replace / update
            defineYourself: JSON.stringify(defineYourself),
            isMcm: isMcm,
            gamEmail: gamEmail,
            gamNetworkCode: gamNetworkId,
            regulation_brand_safety_adserver: regulationAdserver,
            s_type: sellerType,
            s_name: sellerName,
            s_domain: sellerDomain,
            isSellerPassThrough_checkbox: isSellerPassThroughCheckbox,


        };
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (
            defineYourself.length !== 0 &&
            isMcm !== null &&
            (isMcm ? gamEmail !== "" : true) &&
            (isMcm ? gamNetworkId !== "" : true) &&
            regulationAdserver !== "" &&
            (["admin", "u_admin"].includes(checkRole) ? true : sellerType !== "" && sellerName !== "" && sellerDomain !== "")

        ) {
            if (
                defineYourselfIsRequiredError === false &&
                (isMcm ? gamEmailIsRequiredError === false : true) &&
                (isMcm ? gamEmailUrlError === false : true) &&
                (isMcm ? gamNetworkIdIsRequiredError === false : true) &&
                regulationAdserverIsRequiredError === false &&
                (["admin", "u_admin"].includes(checkRole) ? true : sellerTypeIsRequiredError === false && sellerNameIsRequiredError === false && sellerDomainIsRequiredError === false && sellerDomainUrlError === false)
            ) {

                const finalPayload = buildFinalPayload();
                if (!finalPayload) return;

                const formData = objectToFormData(finalPayload);


                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {

                    setButtonValue(true);
                    let token = Cookies.get("token_xapads_ssp");

                    axios
                        .put(`${configData.SERVER_URL}ops/editPub`, formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                "x-access-token": token,
                            }
                        }
                        )
                        .then((response) => {

                            notifysuccess(response.data.message);
                            setTimeout(() => {
                                window.location.reload()
                            }, 1500)


                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error.response.data.message?.length !== 0) {
                                    notifyfailure(error.response.data.message);
                                }
                            } else {
                                notifycatch();
                            }
                            setButtonValue(false);
                        });

                }





            }
        } else {
            if (defineYourself.length === 0) {
                setDefineYourselfIsRequiredError(true);
            }
            if (isMcm === null) {
                setIsMcmIsRequiredError(true);
            }
            if (isMcm && gamEmail === "") {
                setGamEmailIsRequiredError(true);
            }
            if (isMcm && gamNetworkId === "") {
                setGamNetworkIdIsRequiredError(true);
            }
            if (regulationAdserver === "") {
                setRegulationAdserverIsRequiredError(true);
            }
            if (!["admin", "u_admin"].includes(checkRole)) {
                if (sellerType === "") {
                    setSellerTypeIsRequiredError(true);
                }
                if (sellerName === "") {
                    setSellerNameIsRequiredError(true);
                }
                if (sellerDomain === "") {
                    setSellerDomainIsRequiredError(true);
                }
            }
        }
    };





    return (
        <div className="new_table_select_row_design_cls container_box--wrapper pt_header">
            <div className="container_box--wrapper--title d_flex justify-content-between">
                <h1 className="heading fw_600">  My Account </h1>
                {!buttonValue ?
                    <button className='btn btn_primary w_fit_content md' style={{ padding: '0 4rem' }}
                        onClick={handleSubmit}
                        disabled={!isDirty}
                    >
                        <span>

                            Save
                        </span>
                    </button>
                    :
                    <button className='btn btn_primary w_fit_content md' style={{ padding: '0 3rem' }}
                    >
                        <span>

                            Processing...
                        </span>
                    </button>
                }
            </div>
            <div className="d_flex justify_content_between w_100 mb_10">
                <div className="radios_btns --radios_btns_new">
                    <Radio.Group
                        value={tab}
                        className='radio_btn--group mb-0'>
                        <Radio.Button value="generalSettings" onClick={() => { window.location.replace("/generalSettings") }}>General Settings</Radio.Button>
                        <Radio.Button value="accountSettings" >Account Settings</Radio.Button>
                    </Radio.Group>
                </div>

            </div>
            <div className="container_box--form-container bg-transparent border-0 p-0">
                <div className="container_box--width">
                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>Business Type *</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container" >
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className="form_content_block--group m-0">
                                            <div className=''>
                                                <Checkbox.Group className="form_checkbox equal_space"
                                                    value={defineYourself} onChange={onChangeDefineYourself}
                                                // disabled={isDisabled}

                                                >
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width"
                                                        value="Direct Publisher">
                                                        Direct Publisher
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="Aggregator / Reseller">
                                                        Aggregator / Reseller
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="Network with owned & operated apps/sites">
                                                        Network with owned & operated apps/sites
                                                    </Checkbox>
                                                </Checkbox.Group>
                                                <span className="error_content">
                                                    {defineYourselfIsRequiredError && (
                                                        <> This field is required</>
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>MCM Details *</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container" >
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className={isMcm ? "form_content_block--group" : "form_content_block--group mb-0"}>
                                            <div className=''>
                                                <Radio.Group className="form_radio equal_space"
                                                    onChange={onChangeIsMcm} value={isMcm}
                                                // disabled={isDisabled}

                                                >
                                                    <Radio className='radio_btn w-auto' value={true} onChange={onChangeIsMcm}>Yes</Radio>
                                                    <Radio className='radio_btn w-auto' value={false} onChange={onChangeIsMcm}>No</Radio>
                                                </Radio.Group>
                                                <span className="error_content">
                                                    {isMcmIsRequiredError && (
                                                        <> This field is required</>
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                    </Col>
                                    {isMcm && <>
                                        <Col span={12}>
                                            <div className="form_content_block--group mb-0">
                                                <label className="form_label">Google Ad Manager Email ID *</label>
                                                <Input
                                                    className={(gamEmailIsRequiredError || gamEmailUrlError) ? 'form_control basic error' : 'form_control basic'}
                                                    autoComplete="off"
                                                    placeholder="example@gmail.com"
                                                    value={gamEmail}
                                                    onBlur={onBlurGamEmail}
                                                    onChange={onChangeGamEmail}
                                                // disabled={isDisabled}

                                                />
                                                {gamEmailIsRequiredError && (
                                                    <span className="error_content">This field is required</span>
                                                )}

                                                {gamEmailUrlError && (
                                                    <span className="error_content">Invalid Email Address</span>
                                                )}
                                            </div>
                                        </Col>
                                        <Col span={12}>
                                            <div className="form_content_block--group mb-0">
                                                <label className="form_label">GAM Network Code *</label>
                                                <Input
                                                    className={
                                                        gamNetworkIdIsRequiredError
                                                            ? "form_control basic error"
                                                            : "form_control basic"
                                                    }
                                                    value={gamNetworkId}
                                                    onBlur={onBlurGamNetworkId}
                                                    onChange={onChangeGamNetworkId}
                                                    autocomplete="off"
                                                // disabled={isDisabled}

                                                />
                                                {gamNetworkIdIsRequiredError && (
                                                    <span className="error_content">This field is required</span>
                                                )}
                                            </div>
                                        </Col>
                                    </>}

                                </Row>
                            </div>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>Ad Server Details </label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container">
                                <div className="form_content_block--group mb-0">
                                    <label className="form_label">Which adserver do you use? (GAM, SpringServe, Publica, etc.) *</label>
                                    <Input
                                        className={
                                            regulationAdserverIsRequiredError
                                                ? "form_control basic error"
                                                : "form_control basic"
                                        }
                                        value={regulationAdserver}
                                        onBlur={onBlurRegulationAdserver}
                                        onChange={onChangeRegulationAdserver}
                                        // disabled={isDisabled}
                                        autoComplete="off" />
                                    <span className='error_content'>
                                        {regulationAdserverIsRequiredError && (
                                            <> This field is required</>
                                        )}
                                    </span>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    {!["admin", "u_admin"].includes(checkRole) && <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>RTB Seller</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container mb_0" >
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Seller Type  *</label>
                                            <Radio.Group className="form_radio two_radio_box_design_d2 w-100"
                                                onChange={onChangeSellerType} value={sellerType}
                                            // disabled={isDisabled}
                                            >
                                                <Row gutter={16}>
                                                    <Col span={8}>
                                                        <Radio className="radio_btn w-100" value="Publisher">
                                                            Publisher
                                                        </Radio>
                                                    </Col>
                                                    <Col span={8}>
                                                        <Radio className="radio_btn w-100" value="Intermediary">
                                                            Intermediary
                                                        </Radio>
                                                    </Col>
                                                    <Col span={8}>
                                                        <Radio className="radio_btn w-100" value="Both">
                                                            Both
                                                        </Radio>
                                                    </Col>
                                                </Row>
                                            </Radio.Group>
                                            <span className="error_content">
                                                {sellerTypeIsRequiredError && (
                                                    <> This field is required</>
                                                )}
                                            </span>

                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Seller Name *</label>
                                            <Input
                                                className={sellerNameIsRequiredError
                                                    ? "form_control basic error"
                                                    : "form_control basic"
                                                }
                                                value={sellerName}
                                                onBlur={onBlurSellerName}
                                                onChange={onChangeSellerName}
                                                // disabled={isDisabled}
                                                autoComplete="off" />
                                            <span className="error_content">
                                                {sellerNameIsRequiredError && (
                                                    <> This field is required</>
                                                )}
                                            </span>

                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Seller Domain *</label>
                                            <Input
                                                className={(sellerDomainIsRequiredError || sellerDomainUrlError)
                                                    ? "form_control basic error"
                                                    : "form_control basic"
                                                }
                                                value={sellerDomain}
                                                onBlur={onBlurSellerDomain}
                                                onChange={onChangeSellerDomain}
                                                // disabled={isDisabled}
                                                autoComplete="off" />
                                            <span className="error_content">
                                                {sellerDomainIsRequiredError && (
                                                    <> This field is required</>
                                                )}

                                                {sellerDomainUrlError && (
                                                    <> Invalid Domain</>
                                                )}
                                            </span>
                                        </div>
                                    </Col>
                                    <Col span={24}>
                                        <div className="form_content_block--group mb-0">
                                            <div className="primary_checkbox">
                                                <Checkbox
                                                    id="running_ibv_checkbox"
                                                    name="running_ibv_checkbox"
                                                    checked={isSellerPassThroughCheckbox}
                                                    onChange={onChangeIsSellerPassThroughCheckbox}
                                                // disabled={isDisabled}

                                                >
                                                    <span className="form_label">
                                                        Seller Passthrough
                                                    </span>
                                                </Checkbox>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>}
                </div>
            </div>
        </div>
    )
}

export default AccountSetting;
